import { useState, useEffect, useCallback } from 'react';
import { ControllersService } from 'src/services/controllers/controllers.service';
import { ControllerAdditionalInfo } from 'src/types/controllers/controller';

type Props = {
  customerId?: string | null;
  siteId?: string | null;
  gatewayId?: string;
  controllerId?: string;
  includeLatestValues?: boolean;
};

export const useControllerAdditionalInfo = ({
  customerId,
  siteId,
  gatewayId,
  controllerId,
  includeLatestValues,
}: Props) => {
  const [controllerAdditionalInfo, setControllerAdditionalInfo] =
    useState<ControllerAdditionalInfo[]>();

  const getControllerAdditionalInfo = useCallback(() => {
    if (!customerId || !siteId || !gatewayId || !controllerId) return;
    ControllersService.getAdditionalInfoById(
      customerId,
      siteId,
      gatewayId,
      controllerId,
      includeLatestValues
    ).then((response) => {
      setControllerAdditionalInfo(response);
    });
  }, [customerId, siteId, gatewayId, controllerId, includeLatestValues]);

  useEffect(() => {
    getControllerAdditionalInfo();
  }, [getControllerAdditionalInfo]);

  return {
    controllerAdditionalInfo,
    getControllerAdditionalInfo,
  };
};
